<script lang="ts">
  import { findMatch } from "app/utils/filter";
  import { getContext } from "svelte";
  // @ts-ignore
  import { custom_event } from "svelte/internal";
  import { filterKey } from "./DropdownContent.svelte";
  import type { Writable } from "svelte/store";

  export let title = "";
  export let closeOnTrigger = false;

  let ref: HTMLElement;
  let filter = getContext<Writable<string>>(filterKey);
  let isVisible = true;
  $: isVisible = findMatch(title, $filter);

  // this deactive the active element when filtering and the active element is not in the filtered list
  // indirectly closing the inner dropdown when the active element is deselected
  $: if (!isVisible) {
    const event = custom_event("deactivate", title, { bubbles: true });
    ref.dispatchEvent(event);
  }

  // this is used to close the dropdown when clicking on an item that has the closeOnTrigger prop
  function closeOnTriggerFn() {
    if (closeOnTrigger) {
      const closeEvent = custom_event("close", title, { bubbles: true });
      ref.dispatchEvent(closeEvent);
    }
  }
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<li
  bind:this={ref}
  class="list-none"
  class:hidden={!isVisible}
  on:click={closeOnTriggerFn}
  on:keydown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      closeOnTriggerFn();
    }
  }}
>
  {#if isVisible}
    <slot />
  {/if}
</li>
